// Incremental parser for the SSE wire format emitted by PLAN 2's chat endpoint:
//   event: <name>\ndata: <json>\n\n
// Buffers partial chunks and emits decoded AgentSSEEvent objects.

import type { AgentSSEEvent, AgentProposal } from '../types/agent';

function decodeFrame(eventName: string, dataJson: string): AgentSSEEvent | null {
  let data: any;
  try {
    data = JSON.parse(dataJson);
  } catch {
    return null;
  }
  switch (eventName) {
    case 'text':
      return { type: 'text', delta: String(data.delta ?? '') };
    case 'tool_status':
      return {
        type: 'tool_status',
        tool: String(data.tool ?? ''),
        label: String(data.label ?? ''),
      };
    case 'proposal':
      return { type: 'proposal', proposal: data as AgentProposal };
    case 'done':
      return { type: 'done', conversation_id: Number(data.conversation_id) };
    case 'error':
      return { type: 'error', message: String(data.message ?? '') };
    default:
      return null;
  }
}

export interface SSEParser {
  push(chunk: string): AgentSSEEvent[];
}

export function createSSEParser(): SSEParser {
  let buffer = '';

  return {
    push(chunk: string): AgentSSEEvent[] {
      buffer += chunk;
      const events: AgentSSEEvent[] = [];

      let sepIndex: number;
      // Frames are separated by a blank line ("\n\n").
      while ((sepIndex = buffer.indexOf('\n\n')) !== -1) {
        const rawFrame = buffer.slice(0, sepIndex);
        buffer = buffer.slice(sepIndex + 2);

        let eventName = '';
        let dataJson = '';
        for (const line of rawFrame.split('\n')) {
          if (line.startsWith('event:')) {
            eventName = line.slice('event:'.length).trim();
          } else if (line.startsWith('data:')) {
            dataJson += line.slice('data:'.length).trim();
          }
        }
        if (!eventName) continue;
        const decoded = decodeFrame(eventName, dataJson);
        if (decoded) events.push(decoded);
      }
      return events;
    },
  };
}
